export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc 配置文件
	 * @exports
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2014-2015
	 * 
	 */
	var qt_model={};

	//当前版本号
	qt_model.version = window.project_version;

	//接口是否编码
	qt_model.postEncode = false;

	//服务上下文
	qt_model.SERVICE = 'https://bxr.banxiaoer.com';

	//dd服务上下文
	qt_model.DD_SERVICE = 'https://app138287.eapps.dingtalkcloud.com';

	//CDN前缀
	qt_model.CDN_PREFIX = 'https://ks3.weixiao100.cn';

	//静态前缀
	qt_model.STATIC_PREFIX = 'https://www.banxe.cn/school';

    //pro版本路径
	qt_model.PRO_PREFIX = 'https://schoolplus.banxe.cn';


	qt_model.mpAppId = 'wx99aa8c5937f8fde8';

    
	var _isDev = false;
	(function(){
		var hostname =  location.hostname;
        //正式环境
		if(/^(school)\.?/.test(hostname)){
			qt_model.SERVICE = 'https://bxr.banxiaoer.com';
			qt_model.DD_SERVICE = 'https://app138287.eapps.dingtalkcloud.com';
			qt_model.STATIC_PREFIX = 'https://school.banxe.cn/';
			qt_model.WGW_PREFIX = 'https://wgw.banxe.cn';
			qt_model.mpAppId = 'wx4ef76d2da55b136c';
		}
        //测试环境
		if(/^(dev|local|front|127|123)\.?/.test(hostname)){
			_isDev = true;
			qt_model.SERVICE = 'https://dev.banxiaoer.net';
			qt_model.DD_SERVICE = 'https://dtalk.banxiaoer.net';
			qt_model.STATIC_PREFIX = 'https://dev.banxiaoer.net/school';
			qt_model.WGW_PREFIX = 'http://dev.wgw.banxe.cn';
			qt_model.mpAppId = 'wx4ef76d2da55b136c';
            qt_model.PRO_PREFIX = 'https://devschoolplus.banxiaoer.net';
		}
        //beta环境
		if(/^(test)\.?/.test(hostname)){
			_isDev = true;
			qt_model.SERVICE = 'https://test.banxiaoer.net';
			qt_model.DD_SERVICE = 'https://dtalk.banxiaoer.net';
			qt_model.STATIC_PREFIX = 'https://test.banxiaoer.net/school';
			qt_model.WGW_PREFIX = 'http://test.wgw.banxe.cn';
			qt_model.mpAppId = 'wx4ef76d2da55b136c';
		}

        //附加处理本地环境
		if(/^(local|127)\.?/.test(hostname)){
			qt_model.STATIC_PREFIX = '.';
			//qt_model.SERVICE = location.protocol+'//'+location.hostname+(location.port?(':'+location.port):'');
			//qt_model.SERVICE = location.protocol+'//'+'local.banxe.cn:8080';
			qt_model.SERVICE = 'https://dev.banxiaoer.net';
			qt_model.DD_SERVICE = 'https://dtalk.banxiaoer.net';
            qt_model.PRO_PREFIX = 'http://localhost:8081';
		}
	})();

	//是否测试环境
	qt_model.isDev = _isDev;

	return qt_model;
});


// WEBPACK FOOTER //
// ./src/js/config.js